class pageTop {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector('.js-top-about')) {
      this.aboutAnimation();
    }
    if (document.querySelector('.js-scroll-bar')) {
      this.scrollBarAnimation();
    }
    if (document.querySelector('.js-top-workplace-swiper')) {
      this.workplaceSwiper();
    }
    if (document.querySelector('.js-top-staff-swiper')) {
      this.staffSwiper();
    }
  }
  aboutAnimation() {
    const animationWrap = document.querySelector('.js-top-about');
    const logoText = animationWrap.querySelector('.js-top-about__logo-text');
    const map = animationWrap.querySelector('.js-top-about__map');
    const ripple = animationWrap.querySelectorAll('.js-top-about__ripple > div');
    const logo = animationWrap.querySelector('.js-top-about__logo');
    const textWrap = animationWrap.querySelector('.js-top-about__text-wrap');
    const mm = gsap.matchMedia();
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: animationWrap,
        start: "top center",
        end: "bottom top",
        scrub: false
      },
    });
    mm.add('(max-width:767px)', () => {
      tl
        .from(textWrap, {
          opacity: 0,
          duration: 1
        })
        .to(logoText, {
          opacity: 1,
          left: '50%',
          duration: 2
        }, '<=')
        .to(map, {
          opacity: 1,
          y: 0,
          duration: 1
        }, '-=1.5')
        .to(logo, {
          opacity: 1,
          y: '50%',
          ease: "bounce.out",
          duration: 3
        }, '-=1')
        .from(ripple, {
          opacity: 0,
          width: 0,
          duration: 7,
          stagger: {
            each: 0.2
          },
          ease: "power4.out",
        }, '-=2')
    })
    mm.add('(min-width:768px)', () => {
      tl
        .to(logoText, {
          opacity: 1,
          left: '50%',
          duration: 2
        })
        .to(map, {
          opacity: 1,
          y: 0,
          duration: 1
        }, '-=1.5')
        .to(logo, {
          opacity: 1,
          y: '50%',
          ease: "bounce.out",
          duration: 3
        }, '-=1')
        .from(textWrap, {
          opacity: 0,
          duration: 1
        }, '-=2')
        .from(ripple, {
          opacity: 0,
          width: 0,
          duration: 7,
          stagger: {
            each: 0.2
          },
          ease: "power4.out",
        }, '-=2')
    })
  }
  scrollBarAnimation() {
    const barItems = document.querySelectorAll('.js-scroll-bar > img');
    gsap.to(barItems, {
      opacity: 1,
      stagger: 0.5,
      duration: 0.5,
      repeat: -1,
      repeatDelay: 0.8,
    })
  }
  workplaceSwiper() {
    const swiperEle = document.querySelector('.js-top-workplace-swiper');
    new Swiper(swiperEle, {
      loop: true,
      speed: 10000,
      slidesPerView: 'auto',
      autoplay: {
        delay: 0
      }
    })
  }
  staffSwiper() {
    const mm = gsap.matchMedia();
    mm.add('(max-width:768px)', () => {
      new Swiper('.js-top-staff-swiper', {
        spaceBetween: 40,
        slidesPerView: 1.3,
        loop: true,
        autoplay: {
          delay: 4000
        }
      })
    })
  }
}
class Sport {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var swiper = new Swiper('.c-swiper-support', {
      speed: 2000,
      spaceBetween: 10,
      slidesPerView: 1,
      loop: true,
      breakpoints: {
        768: {
          spaceBetween: 16,
          slidesPerView: 3,
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },
      navigation: {
        nextEl: '.s-support-next',
        prevEl: '.s-support-prev',
      },
    })
  }
}

class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.' + this.el).click(function() {
       $(this).next().slideToggle(Number($('html').data('transition')));
       $(this).toggleClass('is-active');
    })
  }
}
class AlpineStore {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    // スマホ判別
    Alpine.store('isMobile', window.innerWidth <= 768);

    function checkScreenSize() {
      Alpine.store('isMobile', window.innerWidth <= 768);
    }

    window.addEventListener('resize', checkScreenSize);

  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
/*
このファイルはwavify.jsをgsap3に対応させ、初回実行時のdurationの調整（バグ調整）をしています。
*/
function wavify(wave_element, options) {
  if ("undefined" === typeof options) options = {};

  //  Options
  var settings = Object.assign(
    {},
    {
      container: options.container ? options.container : "body",
      height: 200,
      amplitude: 100,
      speed: 0.15,
      bones: 3,
      color: "rgba(255,255,255, 0.20)"
    },
    options
  );

  var wave = wave_element,
    width = wave.closest(settings.container).getBoundingClientRect().width,
    height = wave.closest(settings.container).getBoundingClientRect().height,
    points = [],
    lastUpdate,
    totalTime = 0,  // 初期化
    animationInstance = false,
    gsapInstance = false;

  function drawPoints(factor) {
    var points = [];

    for (var i = 0; i <= settings.bones; i++) {
      var x = (i / settings.bones) * width;
      var sinSeed = (factor + (i + (i % settings.bones))) * settings.speed * 100;
      var sinHeight = Math.sin(sinSeed / 100) * settings.amplitude;
      var yPos = Math.sin(sinSeed / 100) * sinHeight + settings.height;
      points.push({ x: x, y: yPos });
    }

    return points;
  }

  function drawPath(points) {
    var SVGString = "M " + points[0].x + " " + points[0].y;

    var cp0 = {
      x: (points[1].x - points[0].x) / 2,
      y: points[1].y - points[0].y + points[0].y + (points[1].y - points[0].y)
    };

    SVGString +=
      " C " +
      cp0.x +
      " " +
      cp0.y +
      " " +
      cp0.x +
      " " +
      cp0.y +
      " " +
      points[1].x +
      " " +
      points[1].y;

    var prevCp = cp0;
    var inverted = -1;

    for (var i = 1; i < points.length - 1; i++) {
      var cp1 = {
        x: points[i].x - prevCp.x + points[i].x,
        y: points[i].y - prevCp.y + points[i].y
      };

      SVGString +=
        " C " +
        cp1.x +
        " " +
        cp1.y +
        " " +
        cp1.x +
        " " +
        cp1.y +
        " " +
        points[i + 1].x +
        " " +
        points[i + 1].y;
      prevCp = cp1;
      inverted = -inverted;
    }

    SVGString += " L " + width + " " + height;
    SVGString += " L 0 " + height + " Z";
    return SVGString;
  }

  // 最初のdrawで波が完全に表示されるように
  var isFirstDraw = true;  // 初回かどうかを判断するフラグ

  function draw() {
    var now = window.Date.now();

    if (lastUpdate) {
      var elapsed = (now - lastUpdate) / 1000;
      lastUpdate = now;

      totalTime += elapsed;
      var factor = totalTime * Math.PI;

      gsapInstance = gsap.to(wave, {
        duration: isFirstDraw ? 0 : settings.speed,  // 初回のみdurationを0に
        attr: {
          d: drawPath(drawPoints(factor))
        },
        ease: "none"
      });

      // 初回描画が終わったらフラグをfalseに設定
      if (isFirstDraw) {
        isFirstDraw = false;
      }
    } else {
      lastUpdate = now;
    }

    // 次のフレームで再度呼び出される
    animationInstance = requestAnimationFrame(draw);
  }


  // 初期設定のスケールを1に固定
  function boot() {
    if (!animationInstance) {
      gsap.set(wave, { attr: { fill: settings.color }, scale: 1 });  // スケール1で固定
      play();
      window.addEventListener("resize", redraw);
    }
  }

  function play() {
    if (!animationInstance) {
      animationInstance = requestAnimationFrame(draw);
    }
  }

  function pause() {
    if (animationInstance) {
      cancelAnimationFrame(animationInstance);
      animationInstance = false;
    }
  }

  function redraw() {
    pause();
    width = wave.closest(settings.container).getBoundingClientRect().width;
    height = wave.closest(settings.container).getBoundingClientRect().height;
    lastUpdate = false;
    play();
  }

  window.addEventListener("resize", redraw);
  boot();
}

class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //------- サイドナビ アンカー ---------
    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0){
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
        } else {
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })

    
    $('[id*="anchor"]').each(function() {
      let text = $(this).find('.anchorTitle').text();
      let id = $(this).attr('id');
      if(text) {
        let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
        $('.js-sideNav').append(newElement);
      }
    })

    $(".js-sideNav a").click(function() {
      setTimeout(() => {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
      }, 600)
    })


    //------- 〆サイドナビ アンカー ---------

    //------- 画像のheught,widthをrem化 ---------
    $('.text-editor img').each(function(index, el) {
      let width = $(el).attr('width')
      // $(el).attr('width')
      $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
    })
    //------- 画像のheught,widthをrem化 〆 ---------

    //------- アコーディオン ---------
    $('.js-editor-accordion .inner').css({'display': 'none'})

    $('.js-editor-accordion .trigger').on('click', function() {
      $(this).find('.trigger-icon').toggleClass('is-active')
      $(this).next().slideToggle(Number($('html').data('transition')))
    })
    //------- アコーディオン 〆 ---------

    //------- タブ切り替え ---------
    if($(window).innerWidth() >= '769') {

      //------- PCの場合 ---------
      $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
      $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
  
      $('.js-tab .trigger .elementor-element').on('click', function() {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
        $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
        $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
      })
      //------- PCの場合 〆 ---------

    } else {

      //------- SPの場合 ---------
      $('.js-tab').each(function() {
        const _el = $(this)
        const trigger_child = _el.find('.trigger-child')
        _el.find('.inner-child').each(function(index) {
          $(this).before(trigger_child[index])
        })
      })

      $('<span></span>').appendTo('.trigger-child > div')

      $('.inner-child').css({'display': 'none'})
      $('.trigger-child').click(function() {
        $(this).find('span').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- SPの場合 〆 ---------
      
    }
    //------- タブ切り替え 〆 ---------
  }
}
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class HeaderAnimation {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const headerWrap = document.querySelector('.js-header');
    let lastScroll = window.scrollY;
    let scrollTimeout;
    
    // スクロールイベントでスクロール位置を更新
    window.addEventListener("scroll", () => {
      clearTimeout(scrollTimeout);
    
      if (window.scrollY > lastScroll) {
        // 下方向スクロール時のアニメーション
        gsap.to(headerWrap, {
          top: '-25rem',
          backgroundColor: 'transparent',
          paddingBottom: '4.3rem'
        });
      } else {
        if (window.scrollY != 0) {
          // 上方向スクロール時（途中でスクロールが止まっていない時）
          gsap.to(headerWrap, {
            top: '-4rem',
            backgroundColor: '#ECF5F8',
            paddingBottom: '2rem'
          });
        } else {
          // スクロールが一番上に戻った時
          gsap.to(headerWrap, {
            top: '-25rem',
            backgroundColor: 'transparent',
            paddingBottom: '4.3rem'
          });
        }
      }
    
      lastScroll = window.scrollY;
      scrollTimeout = setTimeout(() => {
        gsap.to(headerWrap, {
          top: '-4rem',
          backgroundColor: '#ECF5F8',
          paddingBottom: '2rem'
        });
      }, 800);
    });
    
  }
}
// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class JobList {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if (window.innerWidth >= 768) {
      $(".js-tab-area").each(function() {
        var $tabArea = $(this);
        $tabArea.find(".js-tab-content").hide();
        $tabArea.find(".js-job-tab:first").addClass("is-active");
        $tabArea.find(".js-tab-content:first").show();
      
        $tabArea.find(".js-job-tab").click(function() {
          $tabArea.find(".js-tab-content").hide();
          var index = $(this).index();
          $tabArea.find(".js-tab-content").eq(index).show();
      
          $tabArea.find(".js-job-tab").removeClass("is-active");
          $(this).addClass("is-active");
        });
      });
      
    } else {
      $('.js-acc-trigger').on('click', function() {
        $(this).next('.js-acc-wrap').slideToggle();
        $(this).find('.js-acc-plus').toggleClass('is-active');
      });
    }
  }
}

class Loading {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    scrollBan();
    const loadingBar = document.querySelector('.js-loading-bar');
    const loadingWrap = document.querySelector('.js-loading');
    const tl = gsap.timeline();
    tl
      .to(loadingBar, {
        width: '102%',
        duration: 3,
        ease: "power3.inOut",
        onComplete: () => {
          scrollBan();
        }
      })
      .to(loadingWrap, {
        opacity: 0,
        duration: 1,
        onComplete: () => {
          loadingWrap.remove();
        }
      })
  }
}
class Modal {
  constructor(el,opt){
    this.el = el;
    this.event();
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).on('click', function(e) {
      e.preventDefault();
      $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
      scrollBan();
    })

    $("." + this.el + "-close").on('click', function() {
      $('.js-modal-container').removeClass('is-active');
      scrollBan();
    })
  }
}
// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}
class WaveAnimate {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const waveElements = document.querySelectorAll('.js-wave');
    waveElements.forEach((wave) => {
      const mm = gsap.matchMedia();
      let color, height, bones, amplitude, speed;
      mm.add('(max-width:1100px)', () => {
        color = wave.dataset.color ? wave.dataset.color : 'rgba(150, 97, 255, .8)';
        height = wave.dataset.spHeight ? wave.dataset.spHeight : 20;
        bones = wave.dataset.spBones ? wave.dataset.spBones : 1;
        amplitude = wave.dataset.spAmplitude ? wave.dataset.spAmplitude : 40;
        speed = wave.dataset.spSpeed ? wave.dataset.spSpeed : .25;
      })
      mm.add('(min-width:1100px)', () => {
        color = wave.dataset.color ? wave.dataset.color : 'rgba(150, 97, 255, .8)';
        height = wave.dataset.height ? wave.dataset.height : 20;
        bones = wave.dataset.bones ? wave.dataset.bones : 3;
        amplitude = wave.dataset.amplitude ? wave.dataset.amplitude : 40;
        speed = wave.dataset.speed ? wave.dataset.speed : .25;
      })
      wavify(wave, {
        container: 'svg',
        height: parseFloat(height),
        bones: parseFloat(bones),
        amplitude: parseFloat(amplitude),
        color: color,
        speed: parseFloat(speed)
      })
    })
  }
}

(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {
  new Loading('js-loading');
  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  new WaveAnimate('js-wave');
  new HeaderAnimation('js-header');
  let sport = new Sport('p-sport');
  let jobList = new JobList('c-joblist');

  new pageTop();

  // ------------------------------
  // ページビルダー用
  // ------------------------------
  let modal = new Modal('js-modal');
  let accordion = new Accordion('js-accordion');
  let editor = new Editor('c-content');
});

document.addEventListener('alpine:init', () => {
  new AlpineStore();
})